import dayjs from 'dayjs';
import _ from 'lodash';

export const differenceBetweenObjects = (object: any, base: any) => {
  function changes(object: any, base: any) {
    return _.transform(object, function (result: any, value: string, key: string) {
      if (!_.isEqual(value, base[key])) {
        result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value;
      }
    });
  }
  return changes(object, base);
};

export const truncateArray = <T>(array: [], min: number, max: number): T[] | [] =>
  array.length > 0 ? array.slice(min, max) : [];

export const stripHtmlFromString = (value?: any) => value?.replace(/<[^>]*>?/gm, '');

export const htmlDecode = (value?: string): string | null => {
  if (!value) return '';
  const doc = new DOMParser().parseFromString(value, 'text/html');
  return doc.documentElement.textContent;
};

export const isValidURL = (value: string) => {
  const res = value.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)/g
  );
  return res !== null;
};

export const getResoureNameFromUrl = () => globalThis.location.pathname.replace('/', '');

export const convertStringToNumber = (value: string) => {
  const float = Number.parseFloat(value);
  return Number.isNaN(float) ? '' : float;
};

export const groupBy = (objectArray: [], property: string) => {
  return objectArray.reduce((acc: any, obj) => {
    const key = obj[property];
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
};

export const checkNullArray = (element: (string | null)[]) => {
  if (!element) return false;
  return element.some((a: string) => a === null || a === '');
};

export const removeElementFromArray = (elements: string[], elementToDelete: string | null | number) => {
  if (!elements) return null;
  return elements.filter((item: string) => item !== elementToDelete);
};

export const removeItemFromArray = (array: string[], itemToDelete: string): string[] => {
  if (!array || !itemToDelete) return [];
  const isItemIncluded: boolean = array.includes(itemToDelete);
  const itemSanitize = isItemIncluded ? null : itemToDelete;
  const arrayFiltered = array.filter((item: string) => item !== itemToDelete);
  return removeElementFromArray([...arrayFiltered, itemSanitize], null);
};

export const getInitialFromFullName = (fullname: string) => {
  if (fullname === '' || fullname === undefined) return '';
  const initials = fullname
    .match(/(\b\S)?/g)
    .join('')
    .toUpperCase();
  return initials;
};

export const formatMoney = (number?: string | number, decimals: number = 2, isDollar?: boolean) => {
  const currencySymbol = isDollar ? 'U$S ' : '$';
  if (number || Number(number) === 0) {
    const formatted = Number.parseFloat(`${number}`.replace('$', currencySymbol));
    // es-AR y no es-ES: España no separa los miles hasta las cinco cifras, asi
    // que un pago de $4.500 se leia "$ 4500" y recien a partir de $10.000
    // aparecia el punto. El resto del portal ya usa es-AR.
    return `${currencySymbol} ${formatted.toLocaleString('es-AR', {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals,
    })
    }`;
  }
  return `${currencySymbol} 0`;
};

export const formatNumberWithKSeparator = (number: number) => {
  if (typeof number !== 'number') {
    return number;
  }
   if (number >= 1000 && number < 1000000) {
    return (number / 1000).toFixed(1) + ' K';
  } else if (number >= 1000000) {
    return (number / 1000000).toFixed(1) + ' M';
  } else {
    return Math.floor(number);
  }
};

export const capitalizeString = (stringToCapilize: string, allFirstsLetters = false) => {
  const newString = allFirstsLetters
    ? stringToCapilize.trim().replace(/\w\S*/g, (w) => w.replace(/^\w/, (c) => c.toUpperCase()))
    : stringToCapilize.trim().replace(/^\w/, (c) => c.toUpperCase());
  return newString;
};

export const dateValidation = (date: string) => {
  return dayjs(date).isValid() ? dayjs(date).format('DD/MM/YY') : "-";
};

export const getArrayCharactersFromString = (stringToModify: string) => {
  const strList = [];

  for(let i = 0; i < stringToModify.length; i++) {
    const c = stringToModify.substring(i, i+1);
    strList.push(c);
  }

  return strList;
};

export const getNumberDay = (day: string) => {
  switch (day) {
    case 'L':
      return 1;
    case 'M':
      return 2;
    case 'X':
      return 3;
    case 'J':
      return 4;
    case 'V':
      return 5;
    case 'S':
      return 6;
    default:
      return 7;
  }
};